module.exports = "/virtual-football-league/img/video/clubs/germany/schalke04.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/video/clubs/germany/schalke04.png
// module id = 347
// module chunks = 4